/*
 * @Description: 订单管理
 * @Author: 杨志航
 * @Date: 2026-05-09 09:26:47
 */
const orderManage = {
  // 快捷退单列表
  getQuickRefundOrderList: {
    url: '/fortune/order/GetRefundOrderList',
    method: 'get'
  },
  // 退单信息查询与提交
  getRefundOrderQueryList: {
    url: '/fortune/order/GetRefundOrderQueryList',
    method: 'get'
  },
  // 账户管家互转
  getTransferOrderList: {
    url: '/fortune/AccountManageTransfer/getList',
    method: 'get'
  },
  // 360项目账户管家互转导入
  importTransferOrder: {
    url: '/fortune/AccountManageTransfer/upload',
    method: 'post'
  },
}

export default orderManage